export interface AuthIframeProps {
  phones: string[];
  isOpen: boolean;
  close: () => void;
  onSuccess: (accessToken: string) => void;
  onManualClose?: () => void;
}

export enum AuthIframeEventName {
  Finished = 'authenticationFinished',
  Closed = 'authenticationModalClose',
}

export interface AuthIframeEventData {
  name?: AuthIframeEventName;
  access_token?: string;
}
